import { doc, getDoc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

const PROMO_DOC_PATH = ['config', 'promo'];

export async function getPromoConfig() {
  try {
    const ref = doc(db, PROMO_DOC_PATH[0], PROMO_DOC_PATH[1]);
    const snap = await getDoc(ref);
    if (!snap.exists()) {
      return { success: true, data: { enabled: false } };
    }
    return { success: true, data: snap.data() };
  } catch (error) {
    console.error('Erro ao buscar promoção:', error);
    return { success: false, error: error.message };
  }
}

export async function savePromoConfig(config) {
  try {
    const ref = doc(db, PROMO_DOC_PATH[0], PROMO_DOC_PATH[1]);
    await setDoc(ref, { ...config, updatedAt: serverTimestamp() }, { merge: true });
    return { success: true };
  } catch (error) {
    console.error('Erro ao salvar promoção:', error);
    return { success: false, error: error.message };
  }
}

export async function deletePromoConfig() {
  try {
    const ref = doc(db, PROMO_DOC_PATH[0], PROMO_DOC_PATH[1]);
    await deleteDoc(ref);
    return { success: true };
  } catch (error) {
    console.error('Erro ao excluir promoção:', error);
    return { success: false, error: error.message };
  }
}








